import React from 'react';
import { Row } from 'react-bootstrap';
import { FormFilterCard, FormCol, sqlDateTimeUtcStr } from 'motion-components';
import * as Yup from 'yup';

import { useTranslation } from 'react-i18next';
import { splitGmtFromDate } from 'motion-components';
import { useRootStore } from 'store';
import { FieldSelectCollector } from 'shared-pages/components';
import { SelectYear } from 'shared-pages/pages/idocs/components/select-year';

/* ----------- Filters ------------------ */
export const Filters = ({ onChange, initialValues }) => {
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      const startDate =
        new Date(values.year, 0, 1);

      const endDate =
        new Date(values.year, 11, 31, 23, 59, 59);

      onChange({
        year: values.year,
        startDate: splitGmtFromDate(startDate),
        endDate: splitGmtFromDate(endDate),
        collectorId: values.collectorId,
      });
    }, 400);
  }

  const filters = {
    year: initialValues?.year ?? new Date().getFullYear(),
    collectorId: initialValues?.collectorId ?? undefined,
  };

  const formShape = {
    year: Yup.string().required('Το Έτος είναι υποχρεωτικό'),
    collectorId: appStore.isPlatformOwner ? Yup.number().required('Ο Συλλέκτης είναι υποχρεωτικός') : Yup.number().nullable(),
  };

  const validationSchema = Yup.object().shape(formShape);
  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
      validationSchema={validationSchema}
    >
      <Row>
        <SelectYear name="year" title="Έτος" required={true} as={FormCol} />
        {appStore.isPlatformOwner && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
      </Row>
    </FormFilterCard>
  );
};
